import { useState } from 'react';

import { OrganisationAreaContext } from '../contexts';
import {
  OrganisationAreaProviderProps,
  OrganisationAreaSectionType,
} from '../types';

export const OrganisationAreaProvider = ({
  children,
  entity,
}: OrganisationAreaProviderProps) => {
  const [multiselectableSections, setMultiselectableSections] = useState<
    OrganisationAreaSectionType[]
  >([]);
  const [isGroupsEditOverlayOpen, setGroupsEditOverlayOpen] =
    useState<boolean>(false);
  const [isCategoriesEditOverlayOpen, setCategoriesEditOverlayOpen] =
    useState<boolean>(false);

  return (
    <OrganisationAreaContext.Provider
      value={{
        entity,
        multiselectableSections,
        setMultiselectableSections,
        isGroupsEditOverlayOpen,
        setGroupsEditOverlayOpen,
        isCategoriesEditOverlayOpen,
        setCategoriesEditOverlayOpen,
      }}
    >
      {children}
    </OrganisationAreaContext.Provider>
  );
};
